import { cn } from "@workspace/web-ui/lib/utils";

import { CheckIcon, XCircle } from "lucide-react";

interface PasswordRequirementProps {
  fulfilled: boolean;
  text: string;
}

const PasswordRequirement = ({
  fulfilled,
  text,
}: PasswordRequirementProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className={cn(
        "flex items-center justify-center rounded-full w-5 h-5",
        fulfilled ? "" : "text-green-500"
      )}>
        {fulfilled ? <CheckIcon className="text-green-500" /> : <XCircle className="text-red-500"/>}
      </div>
      <span className={cn(
        "text-sm font-normal",
        fulfilled ? "text-green-500" : "text-red-500"
      )}>{text}</span>
    </div>
  );
};

export default PasswordRequirement;